import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';

class MultiStateFilter extends Component {
    state = {
        stateList: [],
        selectedStates: [],
        isLoading: true
    };

    componentDidMount() {
        this.getStates();
    }

    resetStateFilter() {
        this.setState({ selectedStates: [] });
    }

    getStates() {
        axios.get(config.get('API_URL') + '/filters/get-all-states/', {
            headers: { Authorization: ` ${localStorage.usertoken}` },
            params: { user_type: this.props.userType }
        }).then(response => {
            if (Array.isArray(response.data) && response.data.length) {
                const stateList = response.data.map(s => ({
                    value: s.state_name,
                    label: s.state_name
                }));
                this.setState({ stateList, isLoading: false });
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    handleChange(optionSelected) {
        const selected = optionSelected || [];
        const values = selected.map(o => o.value);
        this.props.onSelectState(selected, values);
        this.setState({ selectedStates: selected });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes
                isMulti
                value={this.state.selectedStates}
                options={this.state.stateList}
                onChange={this.handleChange.bind(this)}
                placeholderButtonLabel="Select [State]"
                className="report-listbox"
                isClearable={true}
                isLoading={this.state.isLoading}
            />
        );
    }
}

export default MultiStateFilter;
